import { UpdateContactScreenProps } from "./types"
import React from "react"
import { observer } from "mobx-react-lite"
import { alertSuccess } from "~utils/alert"
import useNavigation from "~hooks/useNavigation"
import { UpdateForm } from "~components/update-form"
import { useStores } from "~models"
import { Event, EventNames, ContactUpdateData, FLAG_ACK } from "~proto"
import { rules, validate, isEmpty } from "~utils/validator"

const UpdateContact: React.FC<UpdateContactScreenProps> = ({ userId }) => {
  const navigation = useNavigation()
  const { eventStore, contactStore } = useStores()
  const contact = contactStore.byUserId(userId)

  const inputs = [
    {
      inputType: "text-input",
      key: "name",
      label: "备注",
      keyboardType: "default",
      placeholder: "请输入备注",
      defaultValue: contact.name,
      clearButtonMode: "while-editing",
      validRule: rules.contact_displayname,
    },
    {
      inputType: "text-input",
      key: "note",
      label: "描述",
      keyboardType: "default",
      placeholder: "添加更多描述信息",
      defaultValue: contact.note,
      clearButtonMode: "while-editing",
      validRule: rules.contact_note,
    },
  ]

  const modalPageTitle = "设置备注"

  const modalPageSubTitle = ""

  const onLeftPress = () => navigation.goBack()

  const handleSubmit = (values) => {
    const evt = new Event<ContactUpdateData>(EventNames.CONTACT_UPDATE, {
      username: contact.username,
      ...values,
    })
    eventStore.publish(evt, { flags: FLAG_ACK })
    alertSuccess({ message: "修改成功" })
    navigation.goBack()
  }

  const handleCancel = () => navigation.goBack()

  const disabledFunc = ({ name, note }) => {
    return (
      (name === contact.displayName && note === contact.note) ||
      !isEmpty(
        validate({ name: rules.contact_displayname, note: rules.contact_note }, { name, note }),
      )
    )
  }

  return (
    <UpdateForm
      modalPageTitle={modalPageTitle}
      modalPageSubTitle={modalPageSubTitle}
      onLeftPress={onLeftPress}
      handleSubmit={handleSubmit}
      handleCancel={handleCancel}
      disabledFunc={disabledFunc}
      inputs={inputs}
      isSubmitConfirm={false}
    />
  )
}

export default observer(UpdateContact)
